import { render, staticRenderFns } from "./IndexVue.vue?vue&type=template&id=4cf19af7&scoped=true&"
import script from "./IndexVue.vue?vue&type=script&lang=js&"
export * from "./IndexVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf19af7",
  null
  
)

export default component.exports